export const getGraphanaLink = (serverDetails) => {
    return `https://dgc.grafana.net/d/oOf7W4pGz/casino-id-level-monitoring?orgId=1&from=now-6h&to=now&var-Site=${serverDetails.siteCode}&var-ServerID=${serverDetails.ServerID}&refresh=1m`;
};

export const getLobbies = (serverDetails) => {
    if (Array.isArray(serverDetails.lobbies)) {
        return serverDetails.lobbies.join(", ");
    }
    return "N/A";
};

export const getSiteCode = (casinoSiteID) => {
    if (!casinoSiteID || typeof casinoSiteID !== 'string') return 'N/A';

    if (casinoSiteID === 'ONP') return 96;
    if (casinoSiteID.endsWith('S')) return 67;
    if (casinoSiteID.endsWith('P')) return 71;

    return 'Unknown';
};

export const getMarketType = (casinoSiteID) => {
    if (!casinoSiteID || typeof casinoSiteID !== 'string') return 'N/A';

    if (casinoSiteID.endsWith('S')) return 'Staging';
    if (casinoSiteID.endsWith('P')) return 'Production';

    return 'Unknown';
};